import React from 'react';
export default function MenuCloser(props) {
    let menuCloserClass;
    props.menuVisible ? menuCloserClass = 'menuCloserVisible' : menuCloserClass = 'menuCloserHidden';
      return (
          <div className={menuCloserClass} onClick={props.toggleMenu}></div>
      );
}
